import { useIdioma } from "@/context/IdiomaContext";
import { Languages } from "lucide-react";

const IDIOMAS = [
  { key: "es", label: "ES" },
  { key: "en", label: "EN" },
];

export const SelectorIdioma = ({ className = "" }) => {
  const { idioma, setIdioma } = useIdioma();
  return (
    <div className={`inline-flex items-center gap-1 rounded-full border border-border px-1.5 py-1 ${className}`}
      data-testid="selector-idioma">
      <Languages className="h-3.5 w-3.5 text-muted-foreground ml-1" />
      {IDIOMAS.map((i) => (
        <button key={i.key} onClick={() => setIdioma(i.key)} data-testid={`idioma-${i.key}`}
          className={`text-xs font-semibold px-2 py-0.5 rounded-full transition-colors duration-200 ${
            idioma === i.key ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
          {i.label}
        </button>
      ))}
    </div>
  );
};
